// extracted by mini-css-extract-plugin
export var bodySections = "_96-8";
export var gray = "_96-7";
export var green = "_96-4";
export var iconContainer = "_96-9";
export var iconWidgetContainer = "_96-1";
export var phoneIcon = "_96-2";
export var red = "_96-5";
export var statusDot = "_96-3";
export var widgetContainer = "_96-0";
export var yellow = "_96-6";